import "@fontsource-variable/inter";
import "@fontsource/jetbrains-mono/400.css";
import "./assets/main.css";
import "vue-sonner/style.css";

import { createApp } from "vue";
import * as Sentry from "@sentry/vue";
import { createPinia } from "pinia";
import { VueQueryPlugin } from "@tanstack/vue-query";

import App from "./App.vue";
import router from "./router";
import { queryClient } from "./lib/query";
import { i18n } from "./i18n";

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(VueQueryPlugin, { queryClient });
app.use(i18n);

// Errors only (no tracing/replay). No DSN (local dev) => not initialised at all.
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    // Never ship the access token or request bodies. Caught AxiosErrors carry
    // config.headers/config.data, which Sentry would serialise into `extra`.
    beforeBreadcrumb(breadcrumb) {
      delete breadcrumb.data?.headers;
      delete breadcrumb.data?.body;
      return breadcrumb;
    },
    beforeSend(event) {
      delete event.request?.headers;
      delete event.request?.data;
      delete event.extra;
      return event;
    },
  });
}

app.mount("#app");
